import { campaignClassificationCatalogHttpAdapter } from './campaign-classification-catalog-http-adapter'
import { campaignCommandHttpAdapter, campaignQueryHttpAdapter } from './campaign-crud-http-adapter'
import { campaignDownloadHttpAdapter } from './campaign-download-http-adapter'
import {
	campaignFileAssociationHttpAdapter,
	campaignFileDiscoveryHttpAdapter,
	campaignFilesHttpAdapter,
} from './campaign-files-http-adapter'
import { campaignLifecycleHttpAdapter } from './campaign-lifecycle-http-adapter'
import { campaignMessageAssociationHttpAdapter } from './campaign-messages-http-adapter'
import { campaignUploadHttpAdapter } from './campaign-upload-http-adapter'

// The single feature-local composition boundary. It selects which
// implementation of each of the ten replaceable operation/data boundaries is
// active and exposes them to the hook layer — all ten are now HTTP-backed
// against the real Campaign Core/Files/Classification APIs, with no
// fixture-backed port remaining here and no request-time fallback into one.
// The preserved in-memory adapters stay independently importable for tests and
// Storybook stories; nothing in this module reaches them. Hooks consume ports
// through this module only; none imports a concrete implementation or
// singleton directly, and no page identifies or branches on which
// implementation is active. Switching an implementation later is a change
// confined to this module. The pure role→capability resolver
// (`lib/campaign-capabilities.ts`) is deliberately absent — it has no
// implementation variants to select between.

export const campaignPorts = {
	query: campaignQueryHttpAdapter,
	command: campaignCommandHttpAdapter,
	lifecycle: campaignLifecycleHttpAdapter,
	files: campaignFilesHttpAdapter,
	discovery: campaignFileDiscoveryHttpAdapter,
	association: campaignFileAssociationHttpAdapter,
	messageAssociation: campaignMessageAssociationHttpAdapter,
	upload: campaignUploadHttpAdapter,
	download: campaignDownloadHttpAdapter,
	classificationCatalog: campaignClassificationCatalogHttpAdapter,
} as const
